import React, { useState } from 'react';
import {
  Button,
  AccordionSummary,
  Typography,
  Accordion,
  AccordionDetails,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useExpansionStyles } from 'components/OrderDetails/styles';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'utilities/hooks/useSnackbar/useSnackbar';

import { slidesSelector } from 'store/slices/slidesSlice';
import {
  ERROR_FETCHING_UPLOADED_ANNOTATIONS,
  HIDE_ANNOTATIONS_LIST_BUTTON_LABEL,
  SHOW_ANNOTATIONS_LIST_BUTTON_LABEL,
} from 'components/ImageViewer/constants';
import { handleBatchUploadAnnotationsAttachment } from 'components/OrderDetails/Tabs/utilities';
import { UploadAnnotationsViewModal } from 'components/OrderSlidesList/ExtAnnotations/UploadAnnotationsModal';
import { useSlideViewerActionsStyles } from 'components/ImageViewer/SlideViewerHeader/styles';
import {
  useGetUploadedSlideAnnotationsQuery,
  useUploadExternalSlideAnnotationsMutation,
} from 'store/apis/slidesApi';
import { useQueryError } from 'utilities/hooks/useQueryError/useQueryError';
import { BatchUploadTable } from 'components/OrderDetails/BatchUploadTable';

export const BatchUploadAnnotationsSection = () => {
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [isTableVisible, setIsTableVisible] = useState(false);
  const { showInfo, showSuccess } = useSnackbar();
  const { classes } = useExpansionStyles();
  const { classes: uploadModalClasses } = useSlideViewerActionsStyles();
  const slides = useSelector(slidesSelector);
  const { data: uploadedAnnotations, error } =
    useGetUploadedSlideAnnotationsQuery();
  const [uploadSlideAnnotation] = useUploadExternalSlideAnnotationsMutation();
  useQueryError(error, ERROR_FETCHING_UPLOADED_ANNOTATIONS);

  const handleClose = () => {
    setIsUploadModalOpen(false);
  };

  const handleUpload = async (filesToUpload) => {
    await handleBatchUploadAnnotationsAttachment({
      filesToUpload,
      handleClose,
      showInfo,
      uploadSlideAnnotation,
      slides,
      showSuccess,
    });
  };

  return (
    <Accordion defaultExpanded={false}>
      <AccordionSummary
        className={classes.alternativeHeader}
        expandIcon={<ExpandMoreIcon />}
      >
        <Typography variant="body1" color={'inherit'}>
          External Annotations
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.noPaddingAccordion}>
        <Box display="flex" alignItems="center">
          <Button
            variant="contained"
            color="primary"
            onClick={() => setIsUploadModalOpen(true)}
            size="small"
            className={classes.defaultMargin}
          >
            Upload Annotations
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setIsTableVisible(!isTableVisible)}
            size="small"
            className={classes.defaultMargin}
          >
            {isTableVisible
              ? HIDE_ANNOTATIONS_LIST_BUTTON_LABEL
              : SHOW_ANNOTATIONS_LIST_BUTTON_LABEL}
          </Button>
          <Typography>
            Annotation filenames must match with image file names
          </Typography>
        </Box>
        {isTableVisible && (
          <BatchUploadTable
            classes={classes}
            slides={slides}
            uploadedAnnotations={uploadedAnnotations}
          />
        )}
        <UploadAnnotationsViewModal
          onUpload={handleUpload}
          classes={uploadModalClasses}
          open={isUploadModalOpen}
          onClose={() => setIsUploadModalOpen(false)}
          isBatch
        />
      </AccordionDetails>
    </Accordion>
  );
};
